import { ConfirmDialog } from "@/components/ConfirmDialog";

type Props = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function DiscardDialog({ open, onConfirm, onCancel }: Props) {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(o) => !o && onCancel()}
      title="Discard changes?"
      description="Your changes will be lost."
      confirmLabel="Discard"
      destructive
      onConfirm={onConfirm}
    />
  );
}
